export const environment = {
    profileName: 'lappi-test',
    production: false,
    backendUrl: 'https://opinto-opas.demopeppi.ulapland.csc.fi',
    primaryLang: 'fi',
    secondaryLang: 'en',
    tertiaryLang: '',
    redirectRoute: '/fi/etusivu/53896',
    frontPageRoute: {valueFi: '/fi/etusivu/53896', valueEn: '/en/front-page/53896', valueSv: '/'},
    // tähän organisaatiopuun juuren id
    frontPageOrganisationIndex: '63',
    logo: 'assets/lappi/logo',
    favicon: 'assets/lappi/favicon.ico',
    background: 'assets/lappi/LaY-tausta.png',
    headerTransparency: true,
    // tähän voi antaa osoitteen, josta injektoidaan jokin javascript-tiedosto <HEAD>-tagien sisään
    analyticsIcluded: false,
    analytics: '',
    // sivujen title-tiedon perään lisättävä lisäke
    titleExtension: ' | Opinto-opas',
    showSearchField: true,
    showTermSelection: false,
    firstSchoolYear: 2020,
    currentPeriodStartYear: 2026,
    searchPeriod: 2026,
    curriculumPeriods: '',
    showTags: false,
    periodView: false,
    topNavigationBackgroundColor: '#424242',
    primaryFont: 'Roboto',
    secondaryFont: 'Roboto'
  };